module.exports = __webpack_public_path__ + "assets/img/3206.ce4ba537.svg";